import service from '@/utils/request'

export function getIframeApi () {
  return service({
    url: '/api/IM/GetAimDomain',
    method: 'post'
  })
}
export function getIsIframeApi () {
  return service({
    url: '/api/IM/IsIframe',
    method: 'post'
  })
}
export function getLoginInfoApi () {
  return service({
    url: '/api/IM/LoginInfo',
    method: 'post'
  })
}
export function imUrlApi () {
  return service({
    url: '/api/IM/GetImToken',
    method: 'post'
  })
}
